import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { User } from "stream-chat";
import { CustomMessageActions, MessageList } from "stream-chat-react";
import { useTheme } from "../../../hooks/useTheme";

const messageActions = [
    'edit',
    'delete',
    'quote',
    'react',
    'reply'
];

const CustomMessageList = () => {
    const navigate = useNavigate();
    const [showButton, setShowButton] = useState(false);
    const { isMobile } = useTheme();
    const {tab} = useParams();

    useEffect(() => {
        const element = document.querySelector('.str-chat__list');

        const handleScroll = () => {
            if (element) {
                const tolerance = 100;
                const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + tolerance;
                setShowButton(!atBottom);
            }
        };

        if (element) {
            element.addEventListener('scroll', handleScroll);
        }

        // Cleanup
        return () => {
            if (element) {
                element.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const scrollToBottom = () => {
        const element = document.querySelector('.str-chat__list');
        if (element) {
          element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
        }
      };

    const customMessageActions: CustomMessageActions = {
        'Copy Message': async (message, event) => {
            await navigator.clipboard.writeText(message.text || '');
        },
    };
    
    const handleUserClick = (event: React.BaseSyntheticEvent, user: User) => {
        navigate(`/home/${tab}/user/${user.id}`);
    }

    return <>
        <MessageList 
            messageActions={messageActions}
            customMessageActions={customMessageActions}
            onUserClick={handleUserClick}
            returnAllReadData={true}
        />
        {showButton && (<button
                onClick={scrollToBottom}
                className={
                    `absolute bottom-[20px] right-[20px] w-10 h-10 rounded-full flex items-center justify-center
                    bg-brand-bg-1 text-brand-orange border border-brand-border-color
                    hover:bg-gray-50 dark:hover:bg-gray-700
                    transition duration-300
                    `
                }
            >
                <span className="material-symbols-outlined text-[34px] pt-1">
                    keyboard_arrow_down
                </span>
            </button>)}
    </>
}

export default CustomMessageList;